<template>
    <v-container>
        <v-layout
            text-center
            wrap
        >
        <v-flex mb-4>
            <h1 class="display-2 font-weight-bold mb-3">
            About Me
            </h1>
            <p class="subheading font-weight-regular">
            A summary of how I got to where I am now.
            </p>
      </v-flex>
      <v-flex
        mb-4
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">In summary</h2>
        <h3>Average Beginnings</h3>
        <p>I am a Virginia native who grew up in a loving Armed Forces family in the suburbs of Newport News.</p>
        <p>
            A graduate of my hometown university <a href="https://cnu.edu/">Christopher Newport University</a>,
            I built my reputation as a contractor with government agencies in my backyard. After a couple years, 
            I branched out to Richmond, the capital city of my home state to work in private industries and build 
            new skills. Years later, I've returned to Virginia to be close to family and return to the knowlege growth 
            I gained here before.
        </p>
        <h3>What I do today?</h3>
        <p>
            I am currently working with an undisclosed industry leader in open-source and enterprise grade software. In my free-time, 
            I attempt to find open source projects I can contribute to and explore.
        </p>
        <h3>What can I do for You?</h3>
        <p>
            I am currently available for part-time hourly consulting and product development services. For personal inquiries or open-source contributions, please see my 
            <router-link to="/contact">contact information</router-link>.
        </p>
      </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data: () => ({

    })
}
</script>